import { createAction } from 'redux-actions';
import { AviaSearchResult } from '@websky/graphql';

export const SET_SEARCH_RESULTS = 'RESULTS/SET_SEARCH_RESULTS';

export const setSearchResults = createAction<AviaSearchResult>(SET_SEARCH_RESULTS);

export type SetSearchResultsAction = ReturnType<typeof setSearchResults>;

export type ActionSearchResultsTypes = SetSearchResultsAction;
